import { type TemplateDefinition } from "@/components/AIComponents/ExportablesModal/templates/registry";

/**
 * Builds the payload for submitting a single graphic organizer response for an assignment.
 *
 * @param {Object} params
 * @param {string} [params.assignmentId] - The assignment's id
 * @param {string} params.contentId - The id of the content being assigned
 * @param {Object} params.formData - The form data for the selected exportable
 * @param {TemplateDefinition} params.selectedExportable - The selected graphic organizer template
 *
 * @returns {Object} Payload object containing:
 *   - assignment_id: The assignment's id
 *   - content_id: Content id
 *   - data: User-submitted form data for the organizer
 *   - graphic_organizer_type: Type identifier (e.g., "graphic_organizer_anticipation_guide")
 */

const buildAssignedGraphicOrganizerPayload = ({
  assignmentId,
  contentId,
  formData,
  selectedExportable,
}: {
  assignmentId: string | undefined;
  contentId: string;
  formData: any;
  selectedExportable: TemplateDefinition<any>;
}) => {
  const { seti_identifier: setiIdentifier } = selectedExportable;
  const payload = {
    assignment_id: assignmentId,
    content_id: contentId,
    data: formData[setiIdentifier],
    graphic_organizer_type: `graphic_organizer_${setiIdentifier}`,
  };

  return payload;
};

export default buildAssignedGraphicOrganizerPayload;
